/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   *  Вывод списка ответов и комментариев
   */
  app.ClaimItemResponsesView = app.View.extend({
    
    run: function () {
      this.render();
    },
    
    render: function () {
      _.each(this.model.models, (function (itemResponse) {
        var responseView = new app.ClaimItemResponseView({
          model: itemResponse
        });
        this.$el.append(responseView.render().el);
        if(!_.isArray(this.childViews.claimResponseViews)) {
          this.childViews.claimResponseViews = [];
        }
        this.childViews.claimResponseViews.push(responseView);
      }).bind(this));
    }
    
  });
})(jQuery);

}.call(window));